"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighchartsWithOptionsComponent = exports.PubSubAction_ExportHighcharts = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const highcharts_1 = __importDefault(require("highcharts"));
const exporting_1 = __importDefault(require("highcharts/modules/exporting"));
const offline_exporting_1 = __importDefault(require("highcharts/modules/offline-exporting"));
const highcharts_pattern_fill_1 = __importDefault(require("highcharts-pattern-fill"));
const HighchartsThemeFacade_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsThemeFacade");
const AppPubSub_1 = require("src/hello_assets/src/util/PubSub/AppPubSub");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
(0, exporting_1.default)(highcharts_1.default);
(0, offline_exporting_1.default)(highcharts_1.default);
(0, highcharts_pattern_fill_1.default)(highcharts_1.default);
window.Highcharts = highcharts_1.default;
HighchartsThemeFacade_1.HighchartsThemeFacade.applyTheme(HighchartsThemeFacade_1.UsergeekHighchartsTheme.default);
exports.PubSubAction_ExportHighcharts = "PubSubAction_ExportHighcharts";
exports.HighchartsWithOptionsComponent = React.memo(({ options, chartHeight, chartIdentifier }) => {
    const highchartsRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        AppPubSub_1.AppPubSub.subscribe(exports.PubSubAction_ExportHighcharts, (data, topic) => {
            var _a;
            if (lodash_1.default.isEqual(chartIdentifier, data === null || data === void 0 ? void 0 : data.chartIdentifier)) {
                (_a = highchartsRef === null || highchartsRef === void 0 ? void 0 : highchartsRef.current) === null || _a === void 0 ? void 0 : _a.chart.exportChartLocal();
            }
        });
        return () => {
            AppPubSub_1.AppPubSub.unsubscribe(exports.PubSubAction_ExportHighcharts);
        };
    }, [chartIdentifier]);
    const chartContainerHeight = chartHeight || HighchartsCalculationsCommonUtils_1.HighchartsCalculationsCommonUtils.ChartSettings.chartHeight;
    return React.createElement(React.Fragment, null,
        React.createElement(highcharts_react_official_1.default, { ref: highchartsRef, highcharts: highcharts_1.default, options: options, containerProps: { style: { width: "100%", height: chartContainerHeight } }, immutable: true }));
}, lodash_1.default.isEqual);
exports.HighchartsWithOptionsComponent.displayName = "HighchartsWithOptionsComponent";
